<template>
  <div>
    <v-card class="mt-8 mx-8 pa-4">
      <v-card-actions class="text-left">
        <v-row>
          <v-col cols="12" class="text-left">
            <v-icon class="back-link-icon" x-large @click="$router.push('/subscription/index')">mdi-arrow-left
            </v-icon>
          </v-col>
        </v-row>
      </v-card-actions>
      <v-card-title>ویرایش اشتراک</v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" md="3" lg="3" sm="6">
            <v-text-field color="black" v-model="subscription.title" label="عنوان اشتراک"></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field label="کاور"
                          @click="openFileDialog()" prepend-icon="mdi-plus"
                          color="black"
                          v-model="subscription.cover"></v-text-field>
          </v-col>

          <v-col cols="12" md="3">
            <v-text-field label="ویدیو"
                          @click="openVideoDialog()" prepend-icon="mdi-plus"
                          color="black"
                          v-model="subscription.video"></v-text-field>
          </v-col>

          <v-col cols="12" md="3" lg="3" sm="6">
            <v-text-field type="number" color="black" v-model="subscription.price" label="قیمت واقعی"></v-text-field>
          </v-col>
          <v-col cols="12" md="3" lg="3" sm="6">
            <v-text-field type="number" color="black" v-model="subscription.show_price" label="قیمت نمایشی"></v-text-field>
          </v-col>

          <v-col cols="12" md="3" lg="3" sm="6">
            <v-text-field type="number" color="black" v-model="subscription.duration" hint="مثلا برای اشتراک ۳ ماهه عدد ۹۰ وارد شود." label="مدت زمان اشتراک به روز"></v-text-field>
          </v-col>

          <v-col cols="12" md="3" lg="3" sm="6">
            <v-text-field type="number" color="black" v-model="subscription.priority"  label="اولویت نمایش سمت کاربر"></v-text-field>
          </v-col>

          <v-col cols="12" md="3" lg="3" sm="6">
            <v-autocomplete label="دوره ها"
                            :items="courses.data"
                            item-text="title"
                            item-value="id"
                            multiple
                            color="black" v-model="subscription.course_ids">
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="3" lg="3" sm="6">
            <v-autocomplete label="آموزشگاه ها"
                            :items="schools"
                            item-text="name"
                            item-value="id"
                            multiple
                            color="black" v-model="subscription.school_ids">
            </v-autocomplete>
          </v-col>

          <v-col cols="12" md="3" lg="3" sm="6">
            <v-autocomplete label="هنرجو ها"
                            :items="students"
                            item-text="name"
                            item-value="id"
                            multiple
                            color="black" v-model="subscription.student_ids">
            </v-autocomplete>
          </v-col>

          <v-col cols="12">
            <ckeditor color="black" v-model="subscription.subtitle"></ckeditor>
          </v-col>
          <v-col cols="12" class="text-center">
            <v-btn block color="success" class="normal-font-btn" @click="update()">ویرایش</v-btn>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
    <v-dialog v-model="uploadFileDialog" max-width="560px" width="calc(100vw - 24px)">
      <drag-and-drop module="subscription" ref="image-uploader" @closeUploadFileDialog="uploadFileDialog = false"
                     @changeFile="subscription.cover = $event"></drag-and-drop>
    </v-dialog>

    <v-dialog v-model="videoFileDialog" max-width="560px" width="calc(100vw - 24px)">
      <drag-and-drop module="subscription" ref="image-uploader"
                     @closeUploadFileDialog="videoFileDialog = false"
                     @changeFile="subscription.video = $event"></drag-and-drop>
    </v-dialog>
  </div>
</template>

<script>
import DragAndDrop from "@/components/UploadFile/DragAndDrop";

export default {
  name: "SubscriptionEditView",
  components: {DragAndDrop},
  data() {
    return {
      uploadFileDialog: false,
      videoFileDialog: false,
      courses:[],
      schools:[],
      students:[],
      subscription: {
        title: null,
        subtitle: null,
        video: null,
        price: null,
        show_price: null,
        duration: null,
        cover: null,
        priority: null,
        course_ids: null,
        school_ids: null,
        student_ids: null,
      }
    }
  },
  mounted() {
    this.getSubscription()
    this.getCourses()
    this.getSchools()
    this.getStudents()
  },
  methods: {

    getCourses() {
      let url = '/course/crud/index?per_page=100000'
      window.axios.get(url).then((res) => {
        this.courses = res.data.data
        this.loading = false
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },

    getSchools() {
      window.axios.get('school/admin-index').then((res) => {
        this.schools = res.data.data
      })
    },

    getStudents() {
      let url = 'admin/student/index?per_page=25000'
      window.axios.get(url).then((res) => {
        this.students = res.data.data.data
      }).catch((err) => {
        this.openSnackbar(err.response.data.message, '#F1416C')
      })
    },


    update() {
      window.axios.post('order/subscription/update/' + this.$route.params.id, this.subscription).then(() => {
        this.openSnackbar("اشتراک با موفقیت ویرایش شد.", 'success')
      }).catch((err) => {
        if (err.response.status === 422) {
          this.showValidationErrors(err, '#F1416C')
        } else if (err.response.status === 400) {
          this.openSnackbar(err.response.data.message, '#F1416C')
        }
      })
    },
    getSubscription() {
      window.axios.get('order/subscription/get/' + this.$route.params.id).then((res) => {
        const data = res.data.data;
        // Map school_ids, course_ids, and student_ids from the relationships in the response
        this.subscription = {
          title: data.title,
          subtitle: data.subtitle,
          video: data.video,
          price: data.price,
          show_price: data.show_price,
          duration: data.duration,
          cover: data.cover,
          priority: data.priority,
          course_ids: data.courses.map(course => course.id),  // Extract course IDs
          school_ids: data.schools.map(school => school.id),  // Extract school IDs
          student_ids: data.students.map(student => student.id), // Extract student IDs
        };
      })
    },
    openFileDialog() {
      this.uploadFileDialog = true
    },
    openVideoDialog() {
      this.videoFileDialog = true
    },
  }
}
</script>

<style scoped>

</style>
